import { useAnimation } from 'framer-motion'
import { useState } from 'react'
import { useInterval, useTimeout } from 'usehooks-ts'

export function useGradientAnimation() {
  const controls = useAnimation()
  const [isGradientActive, setIsGradientActive] = useState(false)
  const [toggle, setToggle] = useState(true)

  const startGradientAnimation = () => {
    controls.start('gradient1')
    setIsGradientActive(true)
  }

  const toggleGradient = () => {
    controls.start(toggle ? 'gradient2' : 'gradient1')
    setToggle(!toggle)
  }

  useTimeout(startGradientAnimation, 800)

  useInterval(toggleGradient, isGradientActive ? 1000 : null)

  return controls
}
